import { isAppLanguageEnglish } from './headerLocalized';

/** 메뉴 노드 표시명: label(한글) · labelEn(영문) */
export function resolveMenuLabel(item, lang) {
  if (!item) return '';
  const useEn = isAppLanguageEnglish(lang);
  if (useEn && item.labelEn) return item.labelEn;
  return item.label || item.labelEn || '';
}

/** 메뉴 트리 전체에 현재 언어 label 적용 (원본 labelEn은 유지) */
export function localizeMenuTree(nodes, lang) {
  if (!Array.isArray(nodes) || nodes.length === 0) return nodes || [];
  return nodes.map((node) => ({
    ...node,
    label: resolveMenuLabel(node, lang),
    children: node.children?.length ? localizeMenuTree(node.children, lang) : node.children,
  }));
}
